export default "__VITE_ASSET__BeRjqEh6__"